class SubmitCP {
	constructor() {
		this._init()
	}
	_init() {
		const els = document.querySelectorAll('[data-submit-cp]')
		els.forEach(el => el.addEventListener('submit', this.onSubmit.bind(null, el)))
	}
	onSubmit(el, ev) {
        el.querySelectorAll('input, select').forEach(input => {
            var inputSrc = document.querySelector('[data-name='+input.name+']')

            if (!inputSrc) {
                return
            }

            if (inputSrc.type == 'checkbox') {
                input.value = inputSrc.checked ? '1' : '0';
            } else {
                input.value = inputSrc.value;
            }
        })
	}
}

export default SubmitCP